import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative w-full bg-black overflow-hidden pb-12" data-id="element-202">
      {/* Cinematic red glow backdrop */}
      <div className="absolute inset-0 z-0" data-id="element-203">
        <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[800px] h-[800px] rounded-full bg-red-700/20 blur-[140px]" data-id="element-204" />
        <div className="absolute inset-0 bg-gradient-radial from-transparent via-black/40 to-black" style={{
        background: 'radial-gradient(ellipse at center, transparent 0%, rgba(0,0,0,0.6) 70%, #000 100%)'
      }} data-id="element-205" />
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-[#0a0a0a] to-transparent z-10" data-id="element-206" />

      {/* Premium Warning Bar */}
      <div className="relative z-20 w-full bg-[#0a0a0a]/80 backdrop-blur-md border-b border-red-900/50 py-3 text-center shadow-[0_0_20px_rgba(220,38,38,0.15)]" data-id="element-207">
        <p className="text-white text-sm md:text-base font-semibold tracking-wide flex items-center justify-center gap-2" data-id="element-208">
          ⚠️ Si sientes que algo cambió en tu rendimiento...
        </p>
      </div>

      {/* Hero Content */}
      <div className="relative z-20 max-w-4xl mx-auto px-6 pt-10 md:pt-16" data-id="element-209">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="text-center" data-id="element-210">
          <p className="text-gray-400 text-xs md:text-sm uppercase tracking-[0.2em] mb-4 font-semibold" data-id="element-211">
            Miles de hombres viven con miedo a que vuelva a pasar.
          </p>

          <div className="relative mb-6" data-id="element-212">
            <div className="absolute inset-0 blur-3xl bg-red-600/20 -z-10" data-id="element-213" />
            <h1 className="font-display text-5xl md:text-7xl lg:text-8xl uppercase leading-[0.95] tracking-tight text-transparent bg-clip-text bg-gradient-to-b from-white via-gray-200 to-gray-400 drop-shadow-[0_0_25px_rgba(220,38,38,0.3)]" data-id="element-214">
              ¿Te preocupa fallar{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-b from-red-500 to-red-700 drop-shadow-[0_0_30px_rgba(220,38,38,0.8)]" data-id="element-215">
                otra vez?
              </span>
            </h1>
          </div>

          <p className="text-base md:text-xl text-gray-300 max-w-2xl mx-auto leading-relaxed mb-10" data-id="element-216">
            Ansiedad sexual, eyaculación precoz o pérdida de erección pueden
            afectar mucho más que tu rendimiento. Recupera tu confianza, tu
            control y tu seguridad.
          </p>
        </motion.div>
      </div>
    </section>;
}